<div class="mc2-wrapper claim-sections">
  <div class="mc2-header" *ngIf="step > 0 && step < 6 && !isReadOnlyView">
    <h4 class="page-title stepper-header"><b>{{ step === 1 ? 'Add Contact Information' : (step === 2 ? 'Upload Submission Form' : (step === 3 ? 'Review Data' : (step === 4 ? 'Upload Supporting Documents' : 'Review &amp; Submit Claims'))) }}</b></h4>
    <div class="stepper-description" *ngIf="step === 2">Upload your submission form and select from recent uploads.</div>
    <div class="stepper-description" *ngIf="step === 3 || step === 4">Review, correct, and attach supporting documents.</div>
    <div class="stepper-description" *ngIf="step === 5">Review and submit all claims in your batch.</div>

    <div id="process-container">
      <div class="process-bar">
        <div class="percent" [style.width.%]="step === 1 ? 0 : (step === 2 ? 25 : (step === 3 ? 50 : (step === 4 ? 75 : 100)))"></div>
        <div class="step-container">
          <span class="step" [ngClass]="{ 'current-step': step === 1, 'active-step': step > 1, 'inactive-step': step < 1 }"></span>
          <span class="step" [ngClass]="{ 'current-step': step === 2, 'active-step': step > 2, 'inactive-step': step < 2 }"></span>
          <span class="step" [ngClass]="{ 'current-step': step === 3, 'active-step': step > 3, 'inactive-step': step < 3 }"></span>
          <span class="step" [ngClass]="{ 'current-step': step === 4, 'active-step': step > 4, 'inactive-step': step < 4 }"></span>
          <span class="step" [ngClass]="{ 'current-step': step === 5, 'active-step': false, 'inactive-step': step < 5 }"></span>
        </div>
      </div>

      <div class="process-legend">
        <div class="legend-col" [class.current-step-label]="step === 1">
          <span>Confirm Payment Recipient</span>
          <span>&amp; Contact Information</span>
        </div>
        <span class="legend-step" [class.current-step-label]="step === 2">Upload Submission Form</span>
        <span class="legend-step" [class.current-step-label]="step === 3">Review Data</span>
        <span class="legend-step" [class.current-step-label]="step === 4">Upload Supporting Documents</span>
        <span class="legend-step" [class.current-step-label]="step === 5">Review &amp; Submit Claims</span>
      </div>
    </div>
  </div>

  <div class="error" *ngIf="systemError">{{ systemError }}</div>
  <div class="error" *ngIf="step === 5 && submitError">{{ submitError }}</div>

  <ng-container *ngIf="!isReadOnlyView">
  <section *ngIf="step === 0" class="landing claim-section file-a-claim-welcome">
    <span class="user-guide d-flex justify-content-end">
      <a href="https://bit.ly/isonlguide" target="_blank" rel="noopener noreferrer">
        {{ 'app.header.accountitems.userguide' | translate }}<mat-icon class="icon-key">open_in_new</mat-icon>
      </a>
    </span>

    <div class="file-a-claim-title">{{ 'claims.edit.navi_isop.titleHVCM' | translate }}</div>
    <div class="file-a-claim-text">{{ 'claims.edit.navi_isop.textHVCM' | translate }}</div>

    <div class="desktop-row-format">
      <div class="first-three-items">
        <div class="item-hvcm">
          <div class="green-number">1.</div>
          <div class="icon">
            <img src="assets/images/add_card.png" />
            <div class="text-top">{{ 'claims.edit.navi_isop.oneHVCM' | translate }}</div>
          </div>
        </div>
        <div class="gray-divider"></div>
        <div class="item-hvcm">
          <div class="green-number">2.</div>
          <div class="icon">
            <img src="assets/images/complete-form.png" />
            <div class="text-top">
              {{ 'claims.edit.navi_isop.twoHVCM1' | translate }}
              <a class="upsc-link" href="" (click)="downloadTemplate($event)">
                {{ 'claims.edit.navi_isop.twoHVCM2' | translate }}
              </a>
            </div>
          </div>
        </div>
        <div class="gray-divider"></div>
        <div class="item-hvcm">
          <div class="green-number spacing-3">3.</div>
          <div class="icon">
            <img src="assets/images/task.png" />
            <div class="text-top">{{ 'claims.edit.navi_isop.threeHVCM' | translate }}</div>
          </div>
        </div>
      </div>

      <div class="last-two-items">
        <div class="item-hvcm spacing-four">
          <div class="green-number spacing-4">4.</div>
          <div class="icon">
            <img src="assets/images/folder_upload.png" />
            <div class="text-4">{{ 'claims.edit.navi_isop.fourHVCM' | translate }}</div>
          </div>
        </div>
        <div class="gray-divider"></div>
        <div class="item-hvcm">
          <div class="green-number">5.</div>
          <div class="icon">
            <img src="assets/images/submit_claim.png" />
            <div class="text-5">{{ 'claims.edit.navi_isop.fiveHVCM' | translate }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="notification-box">
      <upsc-notification-box [isMessage]="true" class="box-format-5">
        <div class="box-format d-flex flex-column" style="align-items: flex-start;">
          <div class="disclaimer d-flex flex-md-row">
            <img src="../../../../../assets/images/info1.png" />
            <div class="text">{{ 'claims.edit.navi_isop.disclaimer' | translate }}</div>
          </div>
          <div class="spacing" style="margin-top: 10px;"></div>
          <div class="text">{{ 'claims.edit.navi_isop.messageHVCM' | translate }}</div>
        </div>
      </upsc-notification-box>
    </div>

    <div class="get-started">
      <button class="upsc-button mc2-btn landing-primary-action" type="button" (click)="onGetStarted()">{{ 'claims.edit.navi_isop.started' | translate }} <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" /></button>
      <button class="upsc-white-button" (click)="downloadTemplate()">{{ 'claims.edit.navi_isop.download' | translate }}<mat-icon>keyboard_arrow_right</mat-icon></button>
    </div>
  </section>

  <section *ngIf="step === 1" class="verify-contact claim-section white-on-gray">
    <div class="verify-caption">Please confirm who should receive updates and notifications</div>
    <hr class="verify-divider" />

    <div class="verify-body">
      <h5><b>Verify Contact Information</b></h5>
      <h6>Who should be contacted for claim updates and notifications?*</h6>

      <label class="radio-container contact-option">
        Same as claim payment recipient.
        <input type="radio" name="contactMode" [value]="false" [(ngModel)]="useDifferentContact" />
        <span class="checkmark"></span>
      </label>

      <label class="radio-container contact-option">
        I would like to enter a different contact name and email address.
        <input type="radio" name="contactMode" [value]="true" [(ngModel)]="useDifferentContact" />
        <span class="checkmark"></span>
      </label>

      <div class="alt-contact" *ngIf="useDifferentContact">
        <div class="contact-grid">
          <input type="text" placeholder="First Name" [(ngModel)]="altContactFirstName" />
          <input type="text" placeholder="Last Name" [(ngModel)]="altContactLastName" />
          <input type="email" placeholder="Email Address" [(ngModel)]="altContactEmail" />
          <input type="text" placeholder="Phone Number" [(ngModel)]="altContactPhone" />
        </div>
      </div>

      <div class="recipient-card" [class.is-loading]="recipientLoading">
        <div class="recipient-card-spinner" *ngIf="recipientLoading"><span class="mc2-spinner"></span></div>
        <h5><b>Claim Payment Recipient</b></h5>
        <h6>{{ recipientName || '-' }}</h6>
        <h6>{{ recipientEmail || '-' }}</h6>
        <h6>{{ recipientPhone || '-' }}</h6>
        <h6 *ngIf="recipientAddressLine1">{{ recipientAddressLine1 }}</h6>
        <h6 *ngIf="recipientAddressLine2">{{ recipientAddressLine2 }}</h6>
      </div>
    </div>

    <div class="step-controls-isop">
      <div class="d-flex continue-save">
        <button class="upsc-button mc2-btn format" type="button" (click)="continueFromVerifyContact()">Continue <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" /></button>
      </div>
    </div>
  </section>

  <section *ngIf="step === 2" class="upload claim-section white-on-gray">
    <div class="step-pane-heading upload-main-heading">
      <h5>Upload your Submission Form Here (500 Records Max)</h5>
      <a class="secondary-button" href="" (click)="downloadTemplate($event)">
        Download Template <img class="template-chevron" src="assets/images/multiclaim2/chevron_right.svg" alt="" />
      </a>
    </div>
    <p class="step-pane-copy">
      With MultiClaim filing, you can quickly file multiple claims in a single submission with ease. All you have to do is upload the file with the shipments you would like to claim while following the provided template.
      After upload, confirm the information provided is correct, upload supporting documents, then submit. In just five easy steps, all your claims will be filed and ready for review by one of our licensed adjusters.
    </p>

    <div class="drop-zone" (dragover)="onDragOver($event)" (drop)="onDrop($event)">
      <div class="drop-zone-legend">
        <img class="drop-zone-icon" src="assets/images/multiclaim2/create_new_folder.svg" alt="Upload" />
        <input id="mc2-file" type="file" accept=".csv,.xls,.xlsx" (change)="onFileChange($event)" hidden />
        <div class="drop-zone-upload-row">
          <label class="input-label" for="mc2-file">Click to upload</label>
          <p>or drag and drop your file here.</p>
        </div>
        <p class="drop-zone-format">CSV, XLS, OR XLSX <span>(500 Records Max)</span></p>
        <div class="selected" *ngIf="selectedFile">{{ selectedFile.name }} <span>is now ready for review</span></div>
      </div>
    </div>

    <div class="error" *ngIf="parseError">{{ parseError }}</div>

    <div class="upload-actions" *ngIf="selectedFile">
      <button class="upsc-button mc2-btn format" type="button" (click)="reviewUpload()">Review <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" /></button>
      <a class="link" (click)="backToLanding()">Cancel</a>
    </div>

    <div class="recent-imports-panel" *ngIf="!selectedFile">
      <div class="step-pane-heading recent-uploads-heading" *ngIf="!historyLoading && recentUploads.length > 0">
        <h5><b>Recent Uploads</b></h5>
      </div>

      <div class="error" *ngIf="historyError">{{ historyError }}</div>
      <div class="recent-imports-loading" *ngIf="historyLoading">Loading imported file history...</div>

      <div class="recent-toolbar" *ngIf="!historyLoading && recentUploads.length > 0">
        <div class="toolbar-left">
          <div class="category-box">
            <label>Search Category</label>
            <select [(ngModel)]="recentSearchCategory">
              <option value="fileName">File Name</option>
              <option value="submissionNumber">Submission #</option>
            </select>
          </div>
          <input
            class="search-input"
            type="text"
            [placeholder]="recentSearchPlaceholder"
            [(ngModel)]="recentSearchText"
            (ngModelChange)="recentCurrentPage = 1"
          />
          <button class="upsc-button mc2-btn search-btn" type="button">Search <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" /></button>
        </div>
        <button class="advanced-filter" type="button" (click)="openAdvancedFilter()">
          <mat-icon aria-hidden="true">filter_alt</mat-icon>
          <span>Advanced Filter</span>
        </button>
      </div>

      <div class="mc2-filter-backdrop" *ngIf="advancedFilterOpen" (click)="closeAdvancedFilter()"></div>
      <aside class="mc2-advanced-filter-panel" *ngIf="advancedFilterOpen" aria-label="Advanced Filter">
        <div class="mc2-advanced-filter-header">
          <h2>Advanced Filter</h2>
          <button type="button" class="mc2-filter-close" aria-label="Close advanced filter" (click)="closeAdvancedFilter()">&times;</button>
        </div>
        <div class="mc2-advanced-filter-content">
          <label>Date Range</label>
          <div class="mc2-filter-date-range">
            <input type="date" aria-label="Start date" [(ngModel)]="advancedStartDate" />
            <input type="date" aria-label="End date" [(ngModel)]="advancedEndDate" />
          </div>
          <hr />
          <label for="advanced-import-status">Import Status</label>
          <select id="advanced-import-status" [(ngModel)]="advancedImportStatus">
            <option value="">Import Status</option>
            <option value="Accepted">Accepted</option>
            <option value="Pending">Pending</option>
            <option value="Cancelled">Cancelled</option>
            <option value="Failed">Failed</option>
          </select>
          <div class="mc2-filter-actions">
            <button type="button" class="upsc-button mc2-btn" (click)="applyAdvancedFilter()">Apply <span aria-hidden="true">&#8250;</span></button>
            <button type="button" class="mc2-filter-reset" (click)="resetAdvancedFilter()">Reset <span aria-hidden="true">&#8250;</span></button>
          </div>
        </div>
      </aside>

      <div class="recent-imports-table" *ngIf="!historyLoading && filteredRecentUploads.length > 0">
        <table class="mc2-table recent-imports-grid">
          <thead>
            <tr>
              <th>File Name</th>
              <th>Imported On</th>
              <th>Imported By</th>
              <th>Submission #</th>
              <th>Import Status</th>
              <th class="table-actions"></th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let upload of visibleRecentUploads">
              <td>
                <a class="table-links" (click)="openRecentUpload(upload)">{{ upload.fileName }}</a>
              </td>
              <td>{{ upload.importedOn ? (getImportedOnDate(upload.importedOn) | date:'medium') : '-' }}</td>
              <td>{{ upload.importedBy || '-' }}</td>
              <td>{{ getSubmissionNumberDisplay(upload) }}</td>
              <td>
                <span class="status-pill" [ngClass]="getRecentStatusClass(upload.importStatus)">{{ getRecentStatusLabel(upload.importStatus) }}</span>
              </td>
              <td class="table-actions">
                <a *ngIf="isFailedUpload(upload)" (click)="showUploadError(upload)">
                  <img class="status-warning" src="assets/images/multiclaim2/warning.svg" alt="Import error" [title]="upload.error" />
                </a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="recent-footer" *ngIf="!historyLoading && filteredRecentUploads.length > 0">
        <div class="table-count">Showing {{ recentStartIndex }} to {{ recentEndIndex }} of {{ filteredRecentUploads.length }} entries</div>
        <div class="pager">
          <button type="button" (click)="goToRecentPage(recentCurrentPage - 1)" [disabled]="recentCurrentPage <= 1">&lsaquo; &lsaquo; Previous</button>
          &nbsp;
          <button type="button" (click)="goToRecentPage(recentCurrentPage + 1)" [disabled]="recentCurrentPage >= recentTotalPages">Next &rsaquo; &rsaquo;</button>
        </div>
        <div class="assets-per-page bottom recent-assets-per-page">
          <label for="recent-page-size">Assets per page</label>
          <select id="recent-page-size" [value]="recentPageSize" (change)="onRecentPageSizeChange($event)">
            <option *ngFor="let size of recentPageSizeOptions" [value]="size">{{ size }}</option>
          </select>
        </div>
      </div>
    </div>
  </section>

  <section *ngIf="step === 3" class="review claim-section review-wrapper">
    <div class="review-error-banner" *ngIf="reviewErrorCount > 0 && editingRowId === null">
      <span class="icon">&#9888;</span>
      <div class="review-error-content">
        <span>{{ reviewErrorCount }} Errors Found. Please fix the errors before submitting</span>
      </div>
    </div>

    <div class="review-top-controls" *ngIf="editingRowId === null">
      <div class="assets-per-page">
        <label for="review-page-size-top">Assets per page</label>
        <select id="review-page-size-top" [value]="pageSize" (change)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
        </select>
      </div>

      <div class="filter-container">
        <button
          type="button"
          id="btnShowAll"
          [class.activeFilter]="reviewFilter === 'all'"
          (click)="setReviewFilter('all')">
          Show All
        </button>
        <button
          type="button"
          id="btnShowErrors"
          [class.activeFilter]="reviewFilter === 'errors'"
          (click)="setReviewFilter('errors')">
          Show Errors
        </button>
      </div>
    </div>

    <div class="legacy-edit-panel" *ngIf="editingRowId !== null && editingDraft">
      <a class="link legacy-back-link" (click)="cancelEditRow()"><span class="legacy-chevron-left">&#8249;</span> Back</a>
      <hr />
      <div class="legacy-edit-header">
        <h3 class="legacy-edit-title">Edit Data</h3>
      </div>

      <form class="legacy-edit-form">
        <div class="legacy-form-col">
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('trackingNumber')">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.trackingNumber" name="trackingNumber" (ngModelChange)="clearTrackingNumberApiError()" />
            <label class="legacy-form-label">{{ isHappyReturnsFlow ? 'Happy Returns ID' : 'Tracking Number' }}</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('trackingNumber')">{{ getEditingFieldMessage('trackingNumber') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('natureOfLoss')" *ngIf="!isHappyReturnsFlow">
            <select class="legacy-form-input legacy-form-select" [(ngModel)]="editingDraft.natureOfLoss" name="natureOfLoss">
              <option value="" disabled selected>Select Nature Of Loss</option>
              <option *ngFor="let option of natureOfLossOptions" [value]="option">{{ option }}</option>
            </select>
            <label class="legacy-form-label">Nature Of Loss</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('natureOfLoss')">{{ getEditingFieldMessage('natureOfLoss') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('merchandiseAmount')">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.merchandiseAmount" name="merchandiseAmount" (ngModelChange)="recalculateEditingTotalAmount()" />
            <label class="legacy-form-label">{{ isHappyReturnsFlow ? 'Item Price' : 'Merchandise Amount' }}</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('merchandiseAmount')">{{ getEditingFieldMessage('merchandiseAmount') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('creditMemo')" *ngIf="!isHappyReturnsFlow">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.creditMemo" name="creditMemo" />
            <label class="legacy-form-label">Credit Memo</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('creditMemo')">{{ getEditingFieldMessage('creditMemo') }}</span>
          </div>
        </div>

        <div class="legacy-form-col">
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('carrier')" *ngIf="!isHappyReturnsFlow">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.carrier" name="carrier" />
            <label class="legacy-form-label">Carrier</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('carrier')">{{ getEditingFieldMessage('carrier') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('merchandiseDescription')">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.merchandiseDescription" name="merchandiseDescription" />
            <label class="legacy-form-label">{{ isHappyReturnsFlow ? 'Product Name' : 'Merchandise Description' }}</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('merchandiseDescription')">{{ getEditingFieldMessage('merchandiseDescription') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('shippingAmount')" *ngIf="!isHappyReturnsFlow">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.shippingAmount" name="shippingAmount" (ngModelChange)="recalculateEditingTotalAmount()" />
            <label class="legacy-form-label">Shipping Amount</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('shippingAmount')">{{ getEditingFieldMessage('shippingAmount') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('additionalComments')">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.additionalComments" name="additionalComments" />
            <label class="legacy-form-label">Additional Comments</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('additionalComments')">{{ getEditingFieldMessage('additionalComments') }}</span>
          </div>
        </div>

        <div class="legacy-form-col">
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('shipDate')">
            <input type="date" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.shipDate" name="shipDate" [max]="todayApiDate" />
            <label class="legacy-form-label">{{ isHappyReturnsFlow ? 'Dropped Off Date' : 'Ship Date' }}</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('shipDate')">{{ getEditingFieldMessage('shipDate') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('replacementTrackingNumber')" *ngIf="!isHappyReturnsFlow">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.replacementTrackingNumber" name="replacementTrackingNumber" />
            <label class="legacy-form-label">Replacement Tracking Number</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('replacementTrackingNumber')">{{ getEditingFieldMessage('replacementTrackingNumber') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('totalAmount')" *ngIf="!isHappyReturnsFlow">
            <input type="text" class="legacy-form-input" placeholder=" " [ngModel]="editingDraft.totalAmount" name="totalAmount" readonly title="Automatically calculated as Merchandise Amount + Shipping Amount" />
            <label class="legacy-form-label">Total Amount</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('totalAmount')">{{ getEditingFieldMessage('totalAmount') }}</span>
          </div>
          <div class="legacy-form-group" [class.has-error]="getEditingFieldMessage('ref1')">
            <input type="text" class="legacy-form-input" placeholder=" " [(ngModel)]="editingDraft.ref1" name="ref1" />
            <label class="legacy-form-label">{{ isHappyReturnsFlow ? 'Happy Returns Retailer ID' : 'Ref 1' }}</label>
            <span class="legacy-form-error" *ngIf="getEditingFieldMessage('ref1')">{{ getEditingFieldMessage('ref1') }}</span>
          </div>
        </div>
      </form>

      <div class="legacy-edit-actions">
        <button type="button" class="legacy-secondary-btn" (click)="cancelEditRow()" [disabled]="editingRowLoading">
          <span class="legacy-chevron-left">&#8249;</span>Cancel
        </button>
        <button class="legacy-primary-btn" type="button" (click)="saveActiveEditedRow()" [disabled]="editingRowLoading || hasEditingValidationErrors()">
          {{ editingRowLoading ? 'Updating...' : 'Update' }}<img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" />
        </button>
      </div>
    </div>

    <div class="review-table-shell" *ngIf="editingRowId === null">
      <table id="tblClaimData" class="mc2-table">
        <thead>
          <tr>
            <th class="table-actions icon-col"></th>
            <th class="table-actions icon-col"></th>
            <th class="table-actions">Select All <input type="checkbox" [checked]="allRowsSelected" [indeterminate]="someRowsSelected" [disabled]="validateClaimsLoading" (change)="toggleSelectAll($event)" /></th>
            <th>{{ isHappyReturnsFlow ? 'Happy Returns ID' : 'Tracking Number' }}</th>
            <th *ngIf="!isHappyReturnsFlow">Carrier</th>
            <th *ngIf="!isHappyReturnsFlow">Nature Of Loss</th>
            <th>{{ isHappyReturnsFlow ? 'Product Name' : 'Merchandise Description' }}</th>
            <th>{{ isHappyReturnsFlow ? 'Dropped Off Date' : 'Ship Date' }}</th>
            <th *ngIf="!isHappyReturnsFlow">Replacement Tracking Number</th>
            <th>{{ isHappyReturnsFlow ? 'Item Price' : 'Merchandise Amount' }}</th>
            <th *ngIf="!isHappyReturnsFlow">Shipping Amount</th>
            <th *ngIf="!isHappyReturnsFlow">Total Amount</th>
            <th *ngIf="!isHappyReturnsFlow">Credit Memo</th>
            <th>Additional Comments</th>
            <th>{{ isHappyReturnsFlow ? 'Happy Returns Retailer ID' : 'Ref1' }}</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of reviewRows">
          <tr [class.review-row-invalid]="isReviewRowInvalid(row)" [class.review-row-editing]="editingRowId === row.id">
            <td class="icon-col status-col">
              <span class="warn-icon-wrap" *ngIf="isReviewRowInvalid(row)" tabindex="0" [attr.aria-label]="getReviewValidationMessages(row).join(' | ')">
                <span class="warn-icon">&#9888;</span>
                <span class="warn-tooltip" role="tooltip">
                  <div class="warn-tooltip-heading">{{ getReviewValidationMessages(row).length }} Error(s) Found</div>
                  <ul class="warn-tooltip-list">
                    <li *ngFor="let detail of getReviewValidationMessages(row)">{{ detail }}</li>
                  </ul>
                </span>
              </span>
            </td>
            <td class="icon-col">
              <button class="edit-row-btn" type="button" aria-label="Edit row" [disabled]="validateClaimsLoading" (click)="startEditRow(row)">&#9998;</button>
            </td>
            <td><input type="checkbox" [(ngModel)]="row.selected" [disabled]="validateClaimsLoading" /></td>
            <td class="tracking-cell" [class.has-error]="hasReviewFieldError(row, 'trackingNumber')">
              <div>{{ isReviewFieldMissing(row, 'trackingNumber') ? 'Please Enter' : (row.trackingNumber || '-') }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'carrier')" *ngIf="!isHappyReturnsFlow">
              <div>{{ isReviewFieldMissing(row, 'carrier') ? 'Please Enter' : (row.carrier || '-') }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'natureOfLoss')" *ngIf="!isHappyReturnsFlow">
              <div>{{ isReviewFieldMissing(row, 'natureOfLoss') ? 'Please Enter' : (row.natureOfLoss || '-') }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'merchandiseDescription')">
              <div>{{ isReviewFieldMissing(row, 'merchandiseDescription') ? 'Please Enter' : (row.merchandiseDescription || '-') }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'shipDate')">
              <div>{{ isReviewFieldMissing(row, 'shipDate') ? 'Please Enter' : getShipDateDisplay(row) }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'replacementTrackingNumber')" *ngIf="!isHappyReturnsFlow">
              <div>{{ row.replacementTrackingNumber || '-' }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'merchandiseAmount')">
              <div>{{ isReviewFieldMissing(row, 'merchandiseAmount') ? 'Please Enter' : (row.merchandiseAmount | number:'1.2-2') }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'shippingAmount')" *ngIf="!isHappyReturnsFlow">
              <div>{{ isReviewFieldMissing(row, 'shippingAmount') ? 'Please Enter' : (row.shippingAmount | number:'1.2-2') }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'totalAmount')" *ngIf="!isHappyReturnsFlow">
              <div>{{ isReviewFieldMissing(row, 'totalAmount') ? 'Please Enter' : (row.totalAmount | number:'1.2-2') }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'creditMemo')" *ngIf="!isHappyReturnsFlow">
              <div>{{ row.creditMemo || '-' }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'additionalComments')">
              <div>{{ row.additionalComments || '-' }}</div>
            </td>
            <td class="field-cell" [class.has-error]="hasReviewFieldError(row, 'ref1')">
              <div>{{ row.ref1 || '-' }}</div>
            </td>
          </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="review-footer-row" *ngIf="editingRowId === null">
      <div class="table-count">Showing {{ reviewStartIndex }} to {{ reviewEndIndex }} of {{ filteredReviewCount }} entries</div>
      <div class="review-pager">
        <button type="button" (click)="goToReviewPage(1)" [disabled]="currentPage <= 1">&#8249;</button>
        <button type="button" (click)="goToReviewPage(currentPage - 1)" [disabled]="currentPage <= 1">Previous</button>
        <button type="button" (click)="goToReviewPage(currentPage + 1)" [disabled]="currentPage >= reviewTotalPages">Next</button>
        <button type="button" (click)="goToReviewPage(reviewTotalPages)" [disabled]="currentPage >= reviewTotalPages">&#8250;</button>
      </div>
      <div class="assets-per-page bottom">
        <label for="review-page-size-bottom">Assets per page</label>
        <select id="review-page-size-bottom" [value]="pageSize" (change)="onPageSizeChange($event)">
          <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
        </select>
      </div>
    </div>

    <div class="error review-action-error" *ngIf="reviewActionError && editingRowId === null">{{ reviewActionError }}</div>

    <div class="step-controls-isop" *ngIf="editingRowId === null">
      <div class="d-flex continue-save submit-update">
        <button class="upsc-button mc2-btn format" type="button" [disabled]="validateClaimsLoading || deleteSelectedLoading" (click)="deleteSelectedRows()">Delete Selected <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" /></button>
        <button class="upsc-button mc2-btn format" type="button" [disabled]="validateClaimsLoading" (click)="continueToDocuments()">{{ validateClaimsLoading ? 'Validating...' : 'Continue' }} <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" /></button>
        <button class="upsc-white-button mc2-btn-secondary" type="button" [disabled]="validateClaimsLoading" (click)="saveForLater()">Save & Continue Later <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right.svg" alt="" /></button>
      </div>
      <div class="d-flex align-items-center ml-auto footer-nav-links">
        <a class="link" [class.disabled]="validateClaimsLoading" [attr.aria-disabled]="validateClaimsLoading" [attr.tabindex]="validateClaimsLoading ? -1 : 0" (click)="backToUploadStep()"><span class="legacy-chevron-left">&#8249;</span> Back</a>
        <a class="link" [class.disabled]="validateClaimsLoading" [attr.aria-disabled]="validateClaimsLoading" [attr.tabindex]="validateClaimsLoading ? -1 : 0" (click)="openCancelUploadModal()">Cancel</a>
      </div>
    </div>

    <div class="error" *ngIf="exportError && editingRowId === null">{{ exportError }}</div>
  </section>

  <div class="mc2-modal-overlay" *ngIf="showContinueConfirmModal">
    <div class="mc2-modal">
      <div class="mc2-modal-header">
        <h5>Would you like to continue?</h5>
        <button type="button" class="mc2-modal-close" aria-label="Close" (click)="closeContinueConfirmModal()">&times;</button>
      </div>
      <div class="mc2-modal-body">
        <p>Once you select "Yes", you will not be able to go back.</p>
        <p>&#x2022; You are about to continue with {{ rows.length }} record(s).</p>
      </div>
      <div class="mc2-modal-footer">
        <button type="button" class="upsc-white-button mc2-btn-secondary" (click)="closeContinueConfirmModal()">
          <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_left.svg" alt="" /> Cancel
        </button>
        <button type="button" class="upsc-button mc2-btn format" (click)="confirmContinueToDocuments()">
          Yes <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" />
        </button>
      </div>
    </div>
  </div>

  <div class="mc2-modal-overlay" *ngIf="showCancelUploadModal">
    <div class="mc2-modal">
      <div class="mc2-modal-header">
        <h5>You are about to cancel the submission.</h5>
        <button type="button" class="mc2-modal-close" aria-label="Close" (click)="closeCancelUploadModal()">&times;</button>
      </div>
      <div class="mc2-modal-body">
        <p>Are you sure you want to cancel this process?</p>
      </div>
      <div class="mc2-modal-footer">
        <button type="button" class="upsc-white-button mc2-btn-secondary" (click)="closeCancelUploadModal()">
          <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_left.svg" alt="" /> No, don't cancel
        </button>
        <button type="button" class="upsc-button mc2-btn format" [disabled]="cancelExportLoading" (click)="confirmCancelUpload()">
          Yes <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" />
        </button>
      </div>
    </div>
  </div>

  <section *ngIf="step === 4" class="documents claim-section white-on-gray">
    <div class="section mb-3">
      <div class="section-title">Upload Supporting Documents</div>
    </div>

    <ng-container *ngIf="activeDocRowId === null">
    <div class="documents-intro">
      <p class="step-pane-copy documents-copy">
        For faster claims resolution, please attach supporting documentation. Don't worry if you don't have all the
        documents ready right now. An adjuster will let you know if additional documents are needed. You may upload
        up to 10 attachments. Each file cannot exceed 7MB. File types such as .jpg, .pdf, docx, .xls and .msg are accepted.
      </p>
      <div class="docs-needed-panel">
        <b>Documents that are likely to be needed:</b>
        <ul>
          <li>
            Invoice or Bill of Sale
          </li>
          <li>
            Proof of Loss
            <span class="doc-help-icon" tabindex="0">
              <img src="assets/images/multiclaim2/help.svg" alt="info" />
              <span class="doc-help-tooltip" role="tooltip">
                <div class="doc-help-heading">Proof of Loss</div>
                <div>This is a document that validates that a loss occurred. It could be a credit memo, an email from the receiver to the shipper notifying non-receipt of the package, a tracking number for a replacement package, etc.</div>
              </span>
            </span>
          </li>
          <li>
            Photos
            <span class="doc-help-icon" tabindex="0">
              <img src="assets/images/multiclaim2/help.svg" alt="info" />
              <span class="doc-help-tooltip" role="tooltip">
                <div class="doc-help-heading">Photos</div>
                <div>Images of the damaged contents as well as that of the box and packaging material are typically needed. Photos of the box should include all sides of the box as well as photos of the packaging material used such as styrofoam, bubble wrap, paper, foam peanuts, etc.</div>
              </span>
            </span>
          </li>
          <li>
            Carrier Notification
            <span class="doc-help-icon" tabindex="0">
              <img src="assets/images/multiclaim2/help.svg" alt="info" />
              <span class="doc-help-tooltip" role="tooltip">
                <div class="doc-help-heading">Carrier Notification</div>
                <div>Please attach proof that the shipping carrier has been notified. Email addresses and shipment identification must be viable in all email attachments. UPS shipments excluded.</div>
              </span>
            </span>
          </li>
        </ul>
      </div>
    </div>

    <div class="loading">
      <div class="bar">
        <div class="fill" [class.complete]="documentsAllPrepared" [style.width.%]="readinessPercent">
          <span class="loading-status" *ngIf="!documentsAllPrepared">{{ readinessPercent }}%</span>
          <span class="loading-status complete" *ngIf="documentsAllPrepared">{{ documentsPreparedCount }}/{{ documentsTotalCount }} have been uploaded</span>
        </div>
      </div>
      <div class="loading-legend">
        <span *ngIf="!documentsAllPrepared">{{ documentsPreparedCount }} out of {{ documentsTotalCount }} claims are being prepared</span>
        <span *ngIf="documentsAllPrepared">You're almost there! Click <a (click)="continueToSummary()">Continue</a> at the bottom of this page to review and submit.</span>
      </div>
    </div>
    <div class="refresh-row" *ngIf="!documentsAllPrepared">
      <button class="upsc-white-button mc2-btn-secondary" type="button" [disabled]="documentsRefreshLoading" (click)="refreshDocumentReadiness()">
        {{ documentsRefreshLoading ? 'Refreshing...' : 'Save & Refresh' }}
      </button>
    </div>

    <div class="review-table-shell">
      <table id="tblDocClaimData" class="mc2-table">
        <thead>
          <tr>
            <th class="table-actions icon-col"></th>
            <th>Tracking Number</th>
            <th>Carrier</th>
            <th>Nature Of Loss</th>
            <th>Merchandise Description</th>
            <th>Ship Date</th>
            <th>Merchandise Amount</th>
            <th>Shipping Amount</th>
            <th>Total Amount</th>
            <th>Additional Comments</th>
            <th>Ref1</th>
            <th>Draft Claim Number</th>
            <th>GWCC Claim Status</th>
            <th>Reason for Failure</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let row of docRows">
          <tr [class.review-row-invalid]="isReviewRowInvalid(row)" [class.review-row-editing]="activeDocRowId === row.id">
            <td class="icon-col status-col">
              <a class="doc-attach-link" [class.has-docs]="getDocumentDisplayCount(row) > 0" [class.disabled]="isDocumentAttachDisabled(row)" (click)="toggleDocRow(row)" [attr.aria-disabled]="isDocumentAttachDisabled(row)" [attr.tabindex]="isDocumentAttachDisabled(row) ? -1 : 0" [attr.title]="getDocumentAttachTitle(row)">
                <img class="label-button-svg" src="assets/images/multiclaim2/paperclip.svg" alt="Attach documents" />
                <span class="doc-count-badge" *ngIf="getDocumentDisplayCount(row) > 0">{{ getDocumentDisplayCount(row) }}</span>
              </a>
            </td>
            <td class="tracking-cell"><div>{{ row.trackingNumber || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.carrier || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.natureOfLoss || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.merchandiseDescription || '-' }}</div></td>
            <td class="field-cell"><div>{{ getShipDateDisplay(row) }}</div></td>
            <td class="field-cell"><div>{{ row.merchandiseAmount | number:'1.2-2' }}</div></td>
            <td class="field-cell"><div>{{ row.shippingAmount | number:'1.2-2' }}</div></td>
            <td class="field-cell"><div>{{ row.totalAmount | number:'1.2-2' }}</div></td>
            <td class="field-cell"><div>{{ row.additionalComments || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.ref1 || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.draftClaimNo || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.gwccClaimStatus || '-' }}</div></td>
            <td class="field-cell"><div>{{ getReasonForFailure(row) }}</div></td>
          </tr>
          </ng-container>
        </tbody>
      </table>
    </div>

    <div class="review-footer-row">
      <div class="table-count">Showing {{ docStartIndex }} to {{ docEndIndex }} of {{ docFilteredCount }} entries</div>
      <div class="review-pager">
        <button type="button" (click)="goToDocPage(1)" [disabled]="docCurrentPage <= 1">&#8249;</button>
        <button type="button" (click)="goToDocPage(docCurrentPage - 1)" [disabled]="docCurrentPage <= 1">Previous</button>
        <button type="button" (click)="goToDocPage(docCurrentPage + 1)" [disabled]="docCurrentPage >= docTotalPages">Next</button>
        <button type="button" (click)="goToDocPage(docTotalPages)" [disabled]="docCurrentPage >= docTotalPages">&#8250;</button>
      </div>
      <div class="assets-per-page bottom">
        <label for="doc-page-size-bottom">Assets per page</label>
        <select id="doc-page-size-bottom" [value]="docPageSize" (change)="onDocPageSizeChange($event)">
          <option *ngFor="let size of docPageSizeOptions" [value]="size">{{ size }}</option>
        </select>
      </div>
    </div>

    <div class="step-controls-isop">
      <div class="d-flex continue-save">
        <button class="upsc-button mc2-btn format" type="button" [disabled]="!documentsAllPrepared" (click)="continueToSummary()">Continue <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" /></button>
        <button class="upsc-white-button mc2-btn-secondary" type="button" (click)="saveForLater()">Save & Continue Later <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right.svg" alt="" /></button>
      </div>
    </div>
    </ng-container>

    <div class="legacy-doc-panel" *ngIf="activeDocRow as activeRow">
      <p class="doc-panel-intro">
        Each file cannot exceed 7MB. File types such as jpg, pdf, docx and xls are accepted. Don't worry if you don't
        have all the documents ready right now, your adjuster will let you know if additional documents are needed.
      </p>
      <a class="link legacy-back-link" (click)="closeDocPanel()"><span class="legacy-chevron-left">&#8249;</span> Back</a>
      <hr />
      <h3 class="legacy-edit-title">Upload Supporting Documents</h3>

      <div class="review-table-shell doc-panel-claim-table">
        <table class="mc2-table">
          <thead>
            <tr>
              <th>Tracking Number</th>
              <th>Carrier</th>
              <th>Nature Of Loss</th>
              <th>Merchandise Description</th>
              <th>Ship Date</th>
              <th>Merchandise Amount</th>
              <th>Shipping Amount</th>
              <th>Total Amount</th>
              <th>Replacement Tracking Number</th>
              <th>Credit Memo</th>
              <th>Additional Comments</th>
              <th>Ref1</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="field-cell"><div>{{ activeRow.trackingNumber || '-' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.carrier || '-' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.natureOfLoss || '-' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.merchandiseDescription || '-' }}</div></td>
              <td class="field-cell"><div>{{ getShipDateDisplay(activeRow) }}</div></td>
              <td class="field-cell"><div>{{ activeRow.merchandiseAmount | number:'1.2-2' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.shippingAmount | number:'1.2-2' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.totalAmount | number:'1.2-2' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.replacementTrackingNumber || '-' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.creditMemo || '-' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.additionalComments || '-' }}</div></td>
              <td class="field-cell"><div>{{ activeRow.ref1 || '-' }}</div></td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="doc-drop-zone" [class.disabled]="isDocumentUploading(activeRow)"
        (click)="!isDocumentUploading(activeRow) && docFileInput.click()"
        upscDragNDrop (onFileDropped)="!isDocumentUploading(activeRow) && onDocumentsDropped($event, activeRow)">
        <input #docFileInput hidden class="doc-file-input" type="file" multiple
          [disabled]="isDocumentUploading(activeRow)" (change)="onDocumentsSelected($event, activeRow)" />
        <img class="doc-drop-zone-icon" src="assets/images/multiclaim2/create_new_folder.svg" alt="Upload" />
        <div class="doc-drop-zone-text">
          <span class="link">Click to upload</span> or drag and drop your file here
        </div>
      </div>

      <div class="uploading-state" *ngIf="isDocumentUploading(activeRow)">Uploading...</div>

      <h5 class="doc-panel-files-heading"><b>Your Files Uploads</b></h5>
      <div class="review-table-shell doc-panel-file-table">
        <table class="mc2-table">
          <thead>
            <tr>
              <th class="icon-col"></th>
              <th>Document Name</th>
              <th>Upload Date</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let doc of activeRow.documents; let i = index">
              <td class="icon-col">
                <button type="button" class="doc-delete-btn" [disabled]="isDocumentDeleting(doc)" (click)="removeDocument(activeRow, i)">{{ isDocumentDeleting(doc) ? '...' : '\u2715' }}</button>
              </td>
              <td class="field-cell"><div>{{ doc.name }}</div></td>
              <td class="field-cell"><div>{{ doc.uploadedDate || '-' }}</div></td>
              <td class="field-cell">
                <span class="file-status" [class.accepted]="doc.status === 'Accepted'" [class.rejected]="doc.status !== 'Accepted'">{{ doc.status || 'Rejected' }}</span>
              </td>
            </tr>
            <tr *ngIf="!activeRow.documents.length">
              <td class="doc-panel-empty" colspan="4">No documents have been uploaded for this claim.</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="doc-panel-actions">
        <button class="legacy-primary-btn" type="button" (click)="closeDocPanel()">
          Save & Continue<img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" />
        </button>
      </div>
    </div>
  </section>


  <section *ngIf="step === 5" class="summary claim-section review-wrapper">
    <div class="summary-contact-grid">
      <div class="summary-contact-card">
        <div class="subsection-title card-heading">Claim Payment Recipient</div>
        <h6>{{ recipientName || '-' }}</h6>
        <h6>{{ recipientEmail || '-' }}</h6>
        <h6>{{ recipientPhone || '-' }}</h6>
        <h6 *ngIf="recipientAddressLine1">{{ recipientAddressLine1 }}</h6>
        <h6 *ngIf="recipientAddressLine2">{{ recipientAddressLine2 }}</h6>
      </div>
      <div class="summary-contact-card">
        <div class="subsection-title card-heading">Contact Information</div>
        <h6>{{ contactDisplayName || '-' }}</h6>
        <h6>{{ contactDisplayEmail || '-' }}</h6>
        <h6>{{ contactDisplayPhone || '-' }}</h6>
      </div>
    </div>

    <div class="summary-card section mb-3">
      <div class="section-title">Claims Information</div>
      <p><b>Number of claims:</b> {{ submissionEligibleClaimsCount }}</p>
      <p><b>Number of claims with documents:</b> {{ claimsWithDocumentsCount }}</p>
    </div>

    <div class="subrogation-terms">
      <label class="check-container">
        <input type="checkbox" [(ngModel)]="acknowledge" />
        <span class="checkmark"></span>
      </label>
      <p>
        By selecting this box, I agree to the Subrogation Terms and certify that all information provided in support of this claim request is true and accurate.
      </p>
    </div>

    <div class="step-controls-isop">
      <div class="d-flex continue-save">
        <button class="upsc-button mc2-btn format" type="button" [disabled]="!acknowledge || submitClaimsLoading" (click)="submitClaims()">
        {{ submitClaimsLoading ? 'Submitting...' : 'Submit' }} <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right_white.svg" alt="" />
      </button>
      <button class="upsc-white-button mc2-btn-secondary" type="button" (click)="saveForLater()">Save & Continue Later <img class="mc2-chevron" src="assets/images/multiclaim2/chevron_right.svg" alt="" /></button>
      </div>
      <div class="d-flex align-items-center ml-auto footer-nav-links">
        <a class="link" (click)="backToReviewFromSummary()"><span class="legacy-chevron-left">&#8249;</span> Back</a>
      </div>
    </div>
  </section>

  <section *ngIf="step === 6" class="claim-section success-page">
    <img src="assets/images/multiclaim2/check_circle.svg" alt="Success" />
    <h3>Thank you for submitting your claims.</h3>
    <div class="success-info">
      <h2>For reference, your submission number is <a>{{ currentSubmissionNumber }}</a></h2>
      <h6>To view the status of your claim, check the "All Claims" page on your InsureShield online portal dashboard. Please allow 24 hours after submission for the most accurate information.</h6>
    </div>
    <button class="upsc-button mc2-btn" type="button" (click)="backToLanding()">Back to MultiClaim Upload Page</button>
  </section>
  </ng-container>

  <section *ngIf="isReadOnlyView" class="read-only-claim-details claim-section">
    <h4 class="page-title stepper-header"><b>Claim Details</b></h4>

    <div class="error" *ngIf="historyError">{{ historyError }}</div>

    <div class="review-table-shell">
      <table class="mc2-table">
        <thead>
          <tr>
            <th>Tracking Number</th>
            <th>Carrier</th>
            <th>Nature Of Loss</th>
            <th>Merchandise Description</th>
            <th>Ship Date</th>
            <th>Merchandise Amount</th>
            <th>Shipping Amount</th>
            <th>Total Amount</th>
            <th>Replacement Tracking Number</th>
            <th>Credit Memo</th>
            <th>Additional Comments</th>
            <th>Ref1</th>
            <th>Draft Claim Number</th>
            <th>GWCC Claim Status</th>
            <th>Reason for Failure</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of docRows">
            <td class="tracking-cell"><div>{{ row.trackingNumber || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.carrier || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.natureOfLoss || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.merchandiseDescription || '-' }}</div></td>
            <td class="field-cell"><div>{{ getShipDateDisplay(row) }}</div></td>
            <td class="field-cell"><div>{{ row.merchandiseAmount | number:'1.2-2' }}</div></td>
            <td class="field-cell"><div>{{ row.shippingAmount | number:'1.2-2' }}</div></td>
            <td class="field-cell"><div>{{ row.totalAmount | number:'1.2-2' }}</div></td>
            <td class="field-cell"><div>{{ row.replacementTrackingNumber || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.creditMemo || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.additionalComments || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.ref1 || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.draftClaimNo || '-' }}</div></td>
            <td class="field-cell"><div>{{ row.gwccClaimStatus || '-' }}</div></td>
            <td class="field-cell"><div>{{ getReasonForFailure(row) }}</div></td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="review-footer-row">
      <div class="table-count">Showing {{ docStartIndex }} to {{ docEndIndex }} of {{ docFilteredCount }} entries</div>
      <div class="review-pager">
        <button type="button" (click)="goToDocPage(1)" [disabled]="docCurrentPage <= 1">&#8249;</button>
        <button type="button" (click)="goToDocPage(docCurrentPage - 1)" [disabled]="docCurrentPage <= 1">Previous</button>
        <button type="button" (click)="goToDocPage(docCurrentPage + 1)" [disabled]="docCurrentPage >= docTotalPages">Next</button>
        <button type="button" (click)="goToDocPage(docTotalPages)" [disabled]="docCurrentPage >= docTotalPages">&#8250;</button>
      </div>
      <div class="assets-per-page bottom">
        <label for="readonly-page-size-bottom">Assets per page</label>
        <select id="readonly-page-size-bottom" [value]="docPageSize" (change)="onDocPageSizeChange($event)">
          <option *ngFor="let size of docPageSizeOptions" [value]="size">{{ size }}</option>
        </select>
      </div>
    </div>

    <div class="step-controls-isop">
      <div class="d-flex continue-save">
        <button class="upsc-button mc2-btn format" type="button" (click)="closeReadOnlyView()">Home</button>
        <button class="upsc-white-button mc2-btn-secondary" type="button" (click)="exportToExcel()">Export to Excel</button>
      </div>
    </div>

    <div class="error" *ngIf="exportError">{{ exportError }}</div>
  </section>
</div>
